import Button from '@/components/Button';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import { Body } from '@/components/Typography';
import { Scalars } from '@/types/graphql';

type Props = {
  hideModal: () => Scalars['Void'];
  onAction: () => Scalars['Void'];
};

const RemoveCertificateModalConfirm = ({ hideModal, onAction }: Props) => {
  return (
    <Modal
      size="sm"
      title="Are you sure you want to remove the certificate?"
      onRequestClose={hideModal}
    >
      <Card.Section>
        <Stack vertical>
          <Body>Are you sure you want to remove worker Certificate?</Body>

          <Stack justify="end">
            <Button
              a11yLabel="deny"
              appearance="outline"
              label="Cancel"
              status="danger"
              type="button"
              onClick={() => {
                hideModal();
              }}
            />

            <Button
              a11yLabel={'Accept'}
              label="Accept"
              type="button"
              onClick={() => {
                onAction();
              }}
            />
          </Stack>
        </Stack>
      </Card.Section>
    </Modal>
  );
};

export default RemoveCertificateModalConfirm;
